const KEYS = {
  AUTH_TOKEN: "AUTH_TOKEN_KEY",
  PROGRAM_ID: "PROGRAM_ID",
};

export const CLAIMS = {
  EXPORT: "export",
  VIEW: "view",
  CANCEL: "cancel",
  EDIT: "edit",
  SYNC: "sync",
} as const;

export type Claim = (typeof CLAIMS)[keyof typeof CLAIMS];

export const STATUS = {
  NONE: 1,
  SUCCESS: 2,
  ERROR: 3,
  CANCELLED: 3,
  WARNING: 3,
  FAILED: 5,
  EARNED: 7,
  PENDING: 6,
} as const;

export default KEYS;
